import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchUserPaths, FetchUserPathsResponse } from "@/api/fetchUserPaths";
import type { UserPathListItem } from "../types";

export interface UserPathsState {
  paths: UserPathListItem[];
  loading: boolean;
  error: string | null;
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
  filters: {
    status?: "active" | "completed" | "paused" | "archived";
  };
}

const initialState: UserPathsState = {
  paths: [],
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  filters: {},
};

export const loadUserPaths = createAsyncThunk(
  "userPaths/loadUserPaths",
  async () => {
    const response = await fetchUserPaths();
    return response;
  },
);

const userPathsSlice = createSlice({
  name: "userPaths",
  initialState,
  reducers: {
    setStatusFilter: (
      state,
      action: PayloadAction<
        "active" | "completed" | "paused" | "archived" | undefined
      >,
    ) => {
      state.filters.status = action.payload;
    },
    clearFilters: (state) => {
      state.filters = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadUserPaths.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadUserPaths.fulfilled, (state, action) => {
        state.loading = false;
        state.paths = action.payload.paths as any;
        // API doesn't provide pagination yet, calculate from data
        state.pagination = {
          currentPage: 1,
          totalPages: 1,
          totalItems: action.payload.paths.length,
          itemsPerPage: action.payload.paths.length || 10,
        };
      })
      .addCase(loadUserPaths.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to load learning paths";
      });
  },
});

export const { setStatusFilter, clearFilters } = userPathsSlice.actions;
export default userPathsSlice.reducer;
